import { Component } from '@badideagames/engine';

export class Flapper extends Component {
  flapForce: number = -300;
  alive: boolean = true;
  rotationTarget: number = 0;
}
